/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamStupenSchvaleniEpk extends GContentBase<SeznamStupenSchvaleniEpkObj> {
        private seznamObj: SeznamStupenSchvaleniEpkObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamStupenSchvaleniEpkObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamStupenSchvaleniEpkNew",
                contentCaption: "jres:33000908", //RC 33000908 : Stupně schválení EPK
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{stav_schvproc}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,stav_schvproc,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamStupenSchvaleniEpkObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailStupenSchvaleniEpk", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailStupenSchvaleniEpk",
                newRecord: isNew,
                stav_schvproc: isNew == true ? null : data.stav_schvproc
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*"
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.StupenSchvaleniEpk.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.stav_schvproc}`,
                nazev: data["nazev"]
            }
        }
    }
}
